import { ApiClientReturnType, KeyLabelType, Nullable } from '~/types'
import api from '../../api/http-common'

const getMilkMoneyToursOptions = () =>
  api.post<ToursOptionsType>('/milk-money/tours/get-index-data')

const getMilkMoneyLogsOptions = () =>
  api.post('/milk-money/ftp-logs/get-index-data')

const getMilkMoneyLogs = (data: any) =>
  api.post('milk-money/tours/changes/index', data)

const getMilkMoneyToursList = (data?) =>
  api.post<ToursDataType>('/milk-money/tours/index', data)

const getMilkMoneyToursCount = (data) =>
  api.post<ToursCountType[]>('/milk-money/tours/count', data)

const importMoneyTours = (data) =>
  api.post('/milk-money/tours/import', data)

const importMoneyToursOptions = () =>
  api.post('/milk-money/tours/import/get-options-data')

const getMoneyToursData = (id: string) =>
  api.post<TourDetailData>(`/milk-money/tours/${id}/show`)

const verifyTour = (id: string) =>
  api.post(`/milk-money/tours/${id}/verify`)

const getSpecificToursData = (id: string, data) =>
  api.post<TourShowData>(`/milk-money/tours/${id}/tour-data/index`, data)

const getChangesToursData = (id: string, data) =>
  api.post(`/milk-money/tours/${id}/changes/index`)

const getMilkDeliveryData = (id: string, idMilk: string) =>
  api.post<TourDeliveryType>(`/milk-money/tours/${id}/tour-data/${idMilk}/edit`)

const deleteMilkDeliveryData = (id: string, idMilk: string) =>
  api.post(`/milk-money/tours/${id}/tour-data/${idMilk}/delete`)

const updateMilkDeliveryData = (id: string, idMilk: string, data) =>
  api.post(`/milk-money/tours/${id}/tour-data/${idMilk}/update`, data)

const storeMilkDeliveryData = (id: string, data) =>
  api.post(`/milk-money/tours/${id}/tour-data/store`, data)

const deleteTour = (id: string, data) =>
  api.post(`/milk-money/tours/${id}/delete`, data)

const deleteMilkDeliveryTour = (id: string, tourDataId, data) =>
  api.post(`/milk-money/tours/${id}/tour-data/${tourDataId}/delete`, data)

const createTour = (data) =>
  api.post('/milk-money/tours/store', data)

const editTour = (id): ApiClientReturnType<EditTourDate> =>
  api.post(`/milk-money/tours/${id}/edit`)

const updateTour = (id, data) =>
  api.post(`/milk-money/tours/${id}/update`, data)

const optionsDataTour = (): ApiClientReturnType<{ dateFrom: Nullable<string> }> =>
  api.post('/milk-money/tours/get-options-data')

const reloadTour = (id: string) =>
  api.post(`/milk-money/tours/${id}/restore`)

const restoreMilkDeliveryTour = (id: string, tourDataId) =>
  api.post(`/milk-money/tours/${id}/tour-data/${tourDataId}/restore`)

// Settings
const getMilkMoneyToursSettings = () =>
  api.post('/settings/milk-money/edit')

const getMilkVAT = () =>
  api.post('/settings/tax/edit')

const updateMilkVAT = (data) =>
  api.post('/settings/tax/update', data)

const updateMilkMoneyToursSettings = (data) =>
  api.post('/settings/milk-money/update', data)

const checkBankIban = (data: { iban: string }) =>
  api.post('/settings/milk-money/check-data', data)

// Farmer side

const getFarmerMilkDeliveries = (data) =>
  api.post('/milk-money/milk-deliveries/index', data)

const getFarmerMilkOptions = () =>
  api.post('/milk-money/milk-deliveries/get-index-data')

// Tour Planning

const getTourPlanningRows = (data) =>
  api.post('/milk-money/tour-planning/index', data)

const getTourTemplateData = (data?) =>
  api.post('/milk-money/tour-planning/template/get-options-data', data)

// Milk samples

const getMilkSamplesIndexData = (id: string, data) =>
  api.post(`/milk-money/milk-samples/${id}/index`, data)

const getSwissMilkSamplesOptions = () =>
  api.post('/milk-money/temp/milk-samples/all-individual-values/get-index-data')

const getSwissMilkSamples = (data: any) =>
  api.post('/milk-money/temp/milk-samples/all-individual-values/index', data)

const getSwissAvgFarmerValuesOptions = () =>
  api.post('/milk-money/temp/milk-samples/farmers-average-values/get-index-data')

const getSwissAvgFarmerValues = (data: any) =>
  api.post('/milk-money/temp/milk-samples/farmers-average-values/index', data)

const getMilkSamplesFilterData = (id: string) =>
  api.post(`/milk-money/milk-samples/${id}/get-index-data`)

const getMilkSamplesShowData = (sampleType: string, id: string) =>
  api.post(`/milk-money/milk-samples/${sampleType}/${id}/show`)

const getMilkSamplesShowFile = (sampleType: string, id: string) =>
  api.post(`/milk-money/milk-samples/${sampleType}/${id}/get-file`)

// MGA factors

const getMgaFactors = () =>
  api.post('/milk-money/mga-factors/edit')

const updateMgaFactors = (data?: any) =>
  api.post('/milk-money/mga-factors/update', data)

// FTP logs

const getMilkMoneyFtpLogs = (data?: any) =>
  api.post('/milk-money/ftp-logs/index', data)

const getMilkMoneyLogsExport = (data?: any) =>
  api.post('/milk-money/ftp-logs/export', data)

const getMilkMoneyLogsFile = (id: string) =>
  api.post(`/milk-money/ftp-logs/${id}/get-file`)

const getMilkMoneyLogFile = (id: string) =>
  api.post(`/milk-money/ftp-logs/${id}/get-log-file`)

const getMilkMoneyFile = (id: string) =>
  api.post(`/milk-money/ftp-logs/${id}/get-file`)

// Shop managment

const getMilkMoneyShopOptions = (data?: any) =>
  api.post('/milk-money/shop/articles/get-options-data', data)

const checkUniqueId = (data?: any) =>
  api.post('/milk-money/shop/articles/check-unique-id', data)

const createMilkMoneyArticle = (data?: any) =>
  api.post('/milk-money/shop/articles/store', data)

const getMilkMoneyArticles = (data?: any) =>
  api.post('/milk-money/shop/articles/index', data)

const getMilkMoneyArticleFile = (id: string, data) =>
  api.post(`/milk-money/shop/articles/${id}/get-file`, data)

const getMilkMoneyArticleFileUrl = (id: string, data) =>
  api.post(`/milk-money/shop/articles/${id}/get-file-url`, data)

const deleteMilkMoneyArticleFile = (id: string, data) =>
  api.post(`/milk-money/shop/articles/${id}/delete-file`, data)

const editMilkMoneyArticle = (id: string) =>
  api.post(`/milk-money/shop/articles/${id}/edit`)

const updateMilkMoneyArticle = (id: string, data: any) =>
  api.post(`/milk-money/shop/articles/${id}/edit`, data)

const deleteMilkMoneyArticle = (id: string) =>
  api.post(`/milk-money/shop/articles/${id}/delete`)

const articleSettingsData = (id: string) =>
  api.post(`/farmers/${id}/articles/get-settings-data`)

const getAriclesBookings = (id: string) =>
  api.post(`milk-money/shop/articles/${id}/update/get-bookings`)

// Invoice

const getInvoiceSettings = (data?) =>
  api.post<MilkMoneyInvoiceSettingsType>('/milk-money/milk-payment/final/invoices/get-settings-data', data)

const generateInvoices = (data?) =>
  api.post('/milk-money/milk-payment/final/invoices/generate', data)

const generatePdfFiles = (data?) =>
  api.post('/milk-money/milk-payment/final/invoices/generate/pdf', data)

const getInvoices = (data?: any) =>
  api.post<MilkMoneyInvoicesType>('/milk-money/milk-payment/final/invoices/index', data)

const getPreviewInvoice = (id?: string) =>
  api.post(`/milk-money/milk-payment/final/invoices/${id}/preview/pdf`)

const exportBankFile = (data?) =>
  api.post('/milk-money/milk-payment/final/bank-file/export', data)

const closeMonth = (data?) =>
  api.post('/milk-money/milk-payment/final/close-month', data)

const generateBankFile = (data?) =>
  api.post('/milk-money/milk-payment/final/bank-file/generate', data)

const editInvoice = (id?: string, data?): ApiClientReturnType<MilkPaymentEditType> =>
  api.post(`/milk-money/milk-payment/final/invoices/${id}/edit`, data)

const updateInvoice = (id: string, data) =>
  api.post(`/milk-money/milk-payment/final/invoices/${id}/update`, data)

const getInvoicePrintSettings = (data?) =>
  api.post('/milk-money/milk-payment/final/invoices/print-preview/get-settings-data', data)

const reacalculateInvoiceFile = (id: string) =>
  api.post(`/milk-money/milk-payment/final/invoices/${id}/generate`)

const submitArticles = (data) =>
  api.post('/milk-money/milk-payment/final/articles/import', data)

// Partial invoice payment

const getPartialInvoiceSettings = (data?): ApiClientReturnType<PartialPaymentSettingsType> =>
  api.post('/milk-money/milk-payment/partial/invoices/get-settings-data', data)

const generatePartialInvoices = (data?) =>
  api.post('/milk-money/milk-payment/partial/invoices/generate', data)

const getPartialInvoices = (data?) =>
  api.post('/milk-money/milk-payment/partial/invoices/index', data)

const generatePartialPdfFiles = (data?) =>
  api.post('/milk-money/milk-payment/partial/invoices/generate/pdf', data)

const previewPartialPdf = (data?) =>
  api.post('/milk-money/milk-payment/partial/invoices/preview/pdf', data)

const generatePartialInvoice = (id: string) =>
  api.post(`/milk-money/milk-payment/partial/invoices/${id}/generate`)

const getPartialPreviewInvoice = (id: string) =>
  api.post(`/milk-money/milk-payment/partial/invoices/${id}/preview/pdf`)

const generatePartialBankFile = (data?) =>
  api.post('/milk-money/milk-payment/partial/bank-file/generate', data)

const closePartialPaymentMonth = (data?) =>
  api.post('/milk-money/milk-payment/partial/close-month', data)

// Additional invoice payment

const getAdditionalInvoiceSettings = (data?): ApiClientReturnType<AdditionalSettingsType> =>
  api.post('/milk-money/milk-payment/additional/invoices/get-settings-data', data)

const generateAdditionalInvoices = (data?) =>
  api.post('/milk-money/milk-payment/additional/invoices/generate', data)

const getAdditionalInvoices = (data?) =>
  api.post('/milk-money/milk-payment/additional/invoices/index', data)

const generateAdditionalPdfFiles = (data?) =>
  api.post('/milk-money/milk-payment/additional/invoices/generate/pdf', data)

const closeAdditionalPaymentMonth = (data?) =>
  api.post('/milk-money/milk-payment/additional/close', data)

const generateAdditionalInvoice = (id: string) =>
  api.post(`/milk-money/milk-payment/additional/invoices/${id}/generate`)

const getAdditionalPreviewInvoice = (id: string) =>
  api.post(`/milk-money/milk-payment/additional/invoices/${id}/preview/pdf`)

const generateAdditionalBankFile = (data?) =>
  api.post('/milk-money/milk-payment/additional/bank-file/generate', data)

// farmer milk deliveries

const getFarmDeliveriesData = (): ApiClientReturnType<{ months: KeyLabelType[] }> =>
  api.post('/milk-money/milk-deliveries/get-index-data')

const getFarmDeliveries = (data?) =>
  api.post('/milk-money/milk-deliveries/index', data)

// farmer milk quality

const getFarmQualityData = (): ApiClientReturnType<{ months: KeyLabelType[] }> =>
  api.post('/milk-money/milk-qualities/get-index-data')

const getFarmQualityList = (data?) =>
  api.post('/milk-money/milk-qualities/index', data)

// farmer milk invoices

const getFarmInvoices = (data) =>
  api.post('/milk-money/milk-invoices/index', data)

// Temp tours

const getTempToursOptions = () =>
  api.post('/milk-money/temp/tours/get-index-data')

const getTempTours = (data?: any) =>
  api.post('/milk-money/temp/tours/index', data)

const getTempTourData = (id: string, data?: any) =>
  api.post(`/milk-money/temp/tours/${id}/tour-data/index`, data)

const MilkMoneyAccountingService = {
  getMilkMoneyToursOptions,
  getMilkMoneyToursList,
  getMilkMoneyToursCount,
  getMilkMoneyToursSettings,
  importMoneyTours,
  updateMilkMoneyToursSettings,
  importMoneyToursOptions,
  getMoneyToursData,
  getSpecificToursData,
  getChangesToursData,
  getMilkDeliveryData,
  storeMilkDeliveryData,
  updateMilkDeliveryData,
  verifyTour,
  deleteMilkDeliveryData,
  getFarmerMilkDeliveries,
  getMilkSamplesIndexData,
  getMilkSamplesFilterData,
  getMilkSamplesShowData,
  getMilkSamplesShowFile,
  getMgaFactors,
  updateMgaFactors,
  getMilkMoneyFtpLogs,
  getMilkMoneyLogsExport,
  getMilkMoneyLogsFile,
  getMilkMoneyLogFile,
  getMilkMoneyFile,
  getMilkMoneyLogsOptions,
  updateMilkVAT,
  getMilkVAT,
  getFarmerMilkOptions,
  getTourPlanningRows,
  createMilkMoneyArticle,
  getMilkMoneyShopOptions,
  checkUniqueId,
  getMilkMoneyArticleFile,
  deleteMilkMoneyArticleFile,
  getMilkMoneyArticles,
  editMilkMoneyArticle,
  updateMilkMoneyArticle,
  deleteMilkMoneyArticle,
  getMilkMoneyArticleFileUrl,
  articleSettingsData,
  generateInvoices,
  getInvoiceSettings,
  getInvoices,
  getPreviewInvoice,
  generateBankFile,
  exportBankFile,
  closeMonth,
  editInvoice,
  updateInvoice,
  getInvoicePrintSettings,
  getAriclesBookings,
  reacalculateInvoiceFile,
  submitArticles,
  getFarmDeliveriesData,
  getFarmDeliveries,
  getFarmQualityData,
  getFarmQualityList,
  getFarmInvoices,
  getTourTemplateData,
  generatePdfFiles,
  getPartialInvoiceSettings,
  generatePartialInvoices,
  getPartialInvoices,
  generatePartialPdfFiles,
  previewPartialPdf,
  generatePartialInvoice,
  getPartialPreviewInvoice,
  generatePartialBankFile,
  closePartialPaymentMonth,
  checkBankIban,
  getAdditionalInvoiceSettings,
  generateAdditionalInvoices,
  getAdditionalInvoices,
  generateAdditionalPdfFiles,
  closeAdditionalPaymentMonth,
  getAdditionalPreviewInvoice,
  generateAdditionalInvoice,
  generateAdditionalBankFile,
  deleteTour,
  deleteMilkDeliveryTour,
  createTour,
  editTour,
  updateTour,
  optionsDataTour,
  reloadTour,
  restoreMilkDeliveryTour,
  getTempToursOptions,
  getTempTours,
  getTempTourData,
  getSwissMilkSamples,
  getSwissMilkSamplesOptions,
  getSwissAvgFarmerValues,
  getSwissAvgFarmerValuesOptions,
  getMilkMoneyLogs
}
export default MilkMoneyAccountingService

export type ToursRowType = {
  convertedTotalAmount: number;
  createdAt: string;
  canBeEdited: number;
  comment?: string;
  dataCount: number;
  dateEnd: string;
  dateStart: string;
  driverNumber: string;
  id: string;
  samplesTotal: number;
  statusLabel: string;
  totalAmount: string;
  tourNumber: string;
  typeLabel: string;
  uniqueId: string;
  vehicleNumber: string;
}

interface ToursDataType {
  filtered: number
  rows: ToursRowType[]
  total: number
}
interface ToursOptionsType {
  milkTestRingExportEnabled: number;
  inCheckStatusAvailable: number;
  vehicleNumbers: string[];
  tourNumbers: string[];
  driverNumbers: string[];
  months: KeyLabelType[];
  statuses: KeyLabelType[];
  exportTypes: KeyLabelType[];
}
interface ToursCountType {
  convertedTotalAmount?: number;
  count: number;
  status: string;
  statusLabel: string;
  typeLabel: string;
}
type SpecificTourType = {
  amount: string;
  avgTemp: string;
  companyName: Nullable<string>;
  convertedAmount: number;
  farmerId: Nullable<string>;
  id: number;
  sampleAvgTemp: Nullable<string>;
  sampleBottleNumber: Nullable<string>;
  status: string;
  supplierNo: string;
  timeFrom: string;
  timeTo: string;
  uniqueId: string;
}
interface TourShowData {
  filtered: number
  rows: SpecificTourType[]
  total: number
}
export interface TourDetailData {
  convertedTotalAmount: number;
  createdAt: string;
  canBeEdited: number;
  dateEnd: string;
  dateStart: string;
  driverNumber: string;
  deleted: number;
  file1: string;
  file2: Nullable<string>;
  ftpImport: number;
  id: string;
  name: Nullable<string>;
  samplesTotal: string;
  status: string;
  statusLabel: string;
  totalAmount: string;
  tourNumber: string;
  type: string;
  typeLabel: string;
  uniqueId: string;
  userId: Nullable<string>;
  vehicleNumber: string;
}
export interface TourDeliveryType {
  amount: string;
  avgTemp: string;
  convertedAmount: number;
  supplierNo: string;
  timeFrom: string;
  timeTo: string;
}
interface MilkMoneyInvoiceSettingsType {
  basePricesSet: number;
  milkSamplesImported: number;
  file: number;
  generatePdfJob: Nullable<GeneratePdfType>
  months: KeyLabelType[];
  selectedMonth: string;
  status: number;
  totalDeliveredAmountInKg: number;
  totalDeliveredAmountInLiters: number;
  hasErrors?: boolean;
}

export type GeneratePdfType = {
  id: number,
  slug: string,
  content_type: string,
  content_id: Nullable<string>,
  created_at: string,
  updated_at: string,
  percentage: number
}

export type FarmerInvoiceType = {
  id: number;
  farmerId: string;
  billingMonth: string;
  supplierNo: string;
  companyName: string;
  amountInKg: number;
  netTotal: string;
  grossTotal: string;
  total: string;
};

type MilkMoneyInvoicesType = {
  rows: FarmerInvoiceType[];
  total: number;
  filtered: number;
};

export interface MilkPaymentEditType {
  milkTests: MilkTest[];
  pseudomonadsTest: unknown;
  milkClasses: MilkClass[];
  milkQualityClassId: number;
  germCountLastMonths: number;
  cellCountLastMonths: number;
  germCount: number;
  cellCount: number;
  farmer: Farmer;
  inhibitorValues: InhibitorValue[];
  date: Date;
  milkQualityUpdateTypes: InhibitorValue[];
}

export interface Farmer {
  id: string;
  companyName: string;
  supplierNo: string;
}

export interface InhibitorValue {
  key: number;
  label: string;
}

export interface MilkClass {
  id: number;
  name: string;
}

export interface MilkTest {
  id: string;
  date: Date;
  fat: null | string;
  protein: null | string;
  lactose: null | string;
  cellCount: number | null;
  germCount: number | null;
  freezingPoint: number | null;
  inhibitor: number;
  urea: number | null;
  fatFreeDryMatter: null | string;
  freeFattyAcid: null | string;
  inhibitorLabel: InhibitorLabel;
}

export interface AccountType {
  id: number;
  name: string;
  iban: string;
  swift: string;
  status: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface PartialPaymentSettingsType extends MilkMoneyInvoiceSettingsType {
  accounts: AccountType[]
  dateFrom: Nullable<string>
  dateTo: Nullable<string>
}

export enum InhibitorLabel {
  Empty = '',
  Neg = 'Neg.',
}

export interface AdditionalSettingsType {
  periods: Period[];
  selectedPeriodId: number;
  status: number;
  file: number;
  generatePdfJob: any;
  accounts: Account[];
  milkTypes: MilkType[];
  hasErrors: number;
}

export interface Account {
  id: number;
  name: string;
  iban: string;
  swift: string;
  status: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface MilkType {
  id: number;
  default: number;
  status: number;
  isBio: number;
  additionalInfo: null;
  abbreviation: string;
  name: string;
  label: string;
  milkTypeId: number;
  languageId: number;
}

export interface Period {
  id: number;
  name: string;
  dateFrom: Date;
  dateTo: Date;
}

export type EditTourDate = {
  date: string,
  typeLabel: string,
  statusLabel: string,
  convertedTotalAmount: number
  vehicleNumber?: string
};
